import { render, staticRenderFns } from "./Doctor_dashboard.vue?vue&type=template&id=32d028af&scoped=true&"
import script from "./Doctor_dashboard.vue?vue&type=script&lang=js&"
export * from "./Doctor_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Doctor_dashboard.vue?vue&type=style&index=0&id=32d028af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d028af",
  null
  
)

export default component.exports